import { render } from "./ProfilePage.vue?vue&type=template&id=16c7ce3c&scoped=true&ts=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"

import "./ProfilePage.vue?vue&type=style&index=0&id=16c7ce3c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c7ce3c"]])

export default __exports__